export type RawError = {
  error: {
    code: string
    message: string
  }
}

export class UnifiedApiError extends Error {
  constructor(
    public statusCode: number,
    public code: string,
    public message: string,
  ) {
    super(`[${code}]: ${message}`)
  }
}

export class UnifiedApiBadRequestError extends UnifiedApiError {
  constructor(
    public statusCode: number,
    public code: string,
    public message: string,
  ) {
    super(statusCode, code, message)
  }
}

export class UnifiedApiInternalServerError extends UnifiedApiError {
  constructor(
    public statusCode: number,
    public code: string,
    public message: string,
  ) {
    super(statusCode, code, message)
  }
}

export enum CreateOrderErrorCode {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  REQUEST_TIMED_OUT = 'REQUEST_TIMED_OUT',
}

export type UnifiedApiConfiguration = {
  longtermToken: string
  endpointUrl?: string
  authorizationStoragePath?: string
}
